import { render, staticRenderFns } from "./ScreeningForm.vue?vue&type=template&id=747e9501&scoped=true&"
import script from "./ScreeningForm.vue?vue&type=script&lang=js&"
export * from "./ScreeningForm.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningForm.vue?vue&type=style&index=0&id=747e9501&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747e9501",
  null
  
)

export default component.exports